import React, { useContext, useEffect, useState } from 'react';
import styles from './ServiceCards.module.scss';
import SwiperCustom from 'components/SwiperCustom/SwiperCustom';
import { SwiperSlide } from 'swiper/react';
import { addCustomPathToLink, generateKey } from '../../functions';
import { Link } from 'react-router-dom';
import 'swiper/css';
import { DataContext } from '../../views/pages/Root';

const ServiceCards = ({ api }) => {
  const subcategories = api.attributes?.subcategories;
  const [date, setDate] = useState();
  const { event_start, event_end } = api.attributes;

  useEffect((_) => {
    const currentDate = new Date().toISOString();
    setDate(currentDate);
  }, []);

  if (!!event_start && !!event_end && (!date || event_start > date || date > event_end)) return null;

  return (
    <section
      id={api?.id}
      className={styles.ServiceCards}
      data-aos="fade-up"
      data-aos-duration="500"
      data-aos-easing="ease-in-out"
      data-aos-once="false"
    >
      {!!api.attributes.title && (
        <h2 className={styles.tittleSection} data-aos="fade-up" data-aos-duration="500" data-aos-easing="ease-in-out" data-aos-once="false">
          {api.attributes.title}
        </h2>
      )}
      <SwiperCustom
        type="swiperthreeCards"
        spaceBetween={10}
        slidesPerView={1.3}
        breakpoints={{
          992: {
            slidesPerView: !!api.attributes?.subcategories ? Math.min(api.attributes.subcategories.length, 4) : 4,
          },
        }}
      >
        {!!subcategories &&
          api.attributes?.subcategories?.map((item) => (
            <SwiperSlide className={styles.swiperSlide} key={generateKey()}>
              <figure>
                <img className={styles.cardImage} src={addCustomPathToLink(item.image.src, true)} alt={item.image.alt} />
              </figure>
              <h4 className={styles.titleCards}>{item.title}</h4>
              <p className={styles.descCards}>{item.description}</p>
              {/* {item['link'] && (
                <Link className={styles.productTitle} to={addCustomPathToLink(`${item['link']}`)}>
                  {item.textBtn}
                </Link>
              )} */}
                {item.btnlink && (
                <Link className={styles.productTitle} to={item.btnlink}>
                  {item.btntext}
                </Link>
              )}
            </SwiperSlide>
          ))}
      </SwiperCustom>
    </section>
  );
};
export default ServiceCards;
